import { ListingPackProduits } from '@components/listing-pack-produits/models';
import { Block } from '@shared/models';
import { ProductTypeKey } from '@shared/services/elastic-search/mappings';

export const listingPackProduitsMock = (productPackType: ProductTypeKey): Block<ListingPackProduits> => ({
  type: 'listing-pack-produits',
  data: {
    productPackType,
  },
});
